// Catches a crash inside any /app screen (BRIEFS C10.1) so Harsh sees a calm message with
// buttons instead of a white page. Resets itself when the address changes.
import React from 'react';
import { useLocation } from 'react-router-dom';
import { CenterMessage } from './AppGate';
import { button } from './theme';

class Boundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('V2 screen error', error, info && info.componentStack);
  }

  componentDidUpdate(prev) {
    if (this.state.failed && prev.resetKey !== this.props.resetKey) {
      this.setState({ failed: false });
    }
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div data-testid="v2-crash">
        <CenterMessage
          title="Something went wrong"
          text="This page stopped working. Press Try again. Your work is saved."
          action={(
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'center' }}>
              <button type="button" style={button.primary} onClick={() => window.location.reload()}>
                Try again
              </button>
              <button type="button" style={button.secondary}
                onClick={() => { window.location.href = '/app'; }}>
                Go to Home
              </button>
            </div>
          )}
        />
      </div>
    );
  }
}

export default function AppErrorBoundary({ children }) {
  const location = useLocation();
  return <Boundary resetKey={location.pathname}>{children}</Boundary>;
}
